module.exports = __webpack_public_path__ + "static/media/win.393c170a.png";